module.exports = __webpack_public_path__ + "img/galery-msu3-2.497ffcdb.png";